import { Commons2 } from '@src/generated/dato-cms';

export const schemaMessages: Record<string, keyof NonNullable<Commons2['tripManagerContent']>> = {
  'any.required': 'validationRequired',
  'any.only': 'validationRequired',
  'options.required': 'optionsRequired',
  'string.empty': 'validationRequired',
  'string.min': 'validationRequired',
  'string.base': 'validationRequired',
  'string.email': 'validationEmailFormat',
};
